export default "__VITE_ASSET__BbqtO$Mx__"